import React, { useState, useMemo } from "react";
import DashboardLayout from "../UI/Layout/DashboardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faShoppingCart,
    faClock,
    faTruck,
    faCheckCircle,
    faSearch,
    faTimes,
    faUser,
    faPhone,
    faCalendarAlt,
    faMapMarkerAlt,
    faBolt,
    faInbox,
    faFilter,
    faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const INITIAL_ORDERS = [
    {
        id: "ord_WA_8293", customer: "Sarah Jenkins",    phone: "+1 (555) 382-9012",  date: "30/06/2026, 06:20:00",
        address: "142 Maple Street, Brooklyn, NY 11201, USA",
        items: 2, total: 37.98,  status: "DELIVERED",  payment: "PAID",   hoursAgo: 5,   daysAgo: 0,  tax: 0,
        orderItems: [{ name: "Wireless Earbuds Pro", qty: 1, price: 24.99 }, { name: "Phone Stand Holder", qty: 1, price: 12.99 }],
    },
    {
        id: "ord_WA_9104", customer: "David Chen",       phone: "+65 9123 4567",       date: "30/06/2026, 08:15:00",
        address: "Blk 45 Toa Payoh Lorong 8, #12-34, Singapore 310045",
        items: 2, total: 148.98, status: "PROCESSING", payment: "PAID",   hoursAgo: 11,  daysAgo: 0,  tax: 0,
        orderItems: [{ name: "Mechanical Keyboard", qty: 1, price: 89.99 }, { name: "USB-C Hub 7-in-1", qty: 1, price: 58.99 }],
    },
    {
        id: "ord_WA_9821", customer: "Amina Al-Mansoor", phone: "+971 50 123 4567",    date: "30/06/2026, 08:40:00",
        address: "Villa 12, Al Barsha South 3, Dubai, UAE",
        items: 1, total: 249.50, status: "PENDING",    payment: "UNPAID", hoursAgo: 18,  daysAgo: 0,  tax: 0,
        orderItems: [{ name: "Ergonomic Task Office Chair", qty: 1, price: 249.50 }],
    },
    {
        id: "ord_WA_7741", customer: "Liam Thompson",    phone: "+44 7700 900123",     date: "29/06/2026, 14:30:00",
        address: "28 Camden High Street, London NW1 0JH, UK",
        items: 3, total: 89.00,  status: "SHIPPED",    payment: "PAID",   hoursAgo: 30,  daysAgo: 1,  tax: 0,
        orderItems: [{ name: "Running Shoes", qty: 1, price: 45.00 }, { name: "Sport Water Bottle", qty: 2, price: 22.00 }],
    },
    {
        id: "ord_WA_6612", customer: "Priya Sharma",     phone: "+91 98765 43210",     date: "29/06/2026, 10:00:00",
        address: "Flat 302, Prestige Towers, Koramangala 4th Block, Bengaluru 560034, India",
        items: 1, total: 55.00,  status: "DELIVERED",  payment: "PAID",   hoursAgo: 48,  daysAgo: 2,  tax: 0,
        orderItems: [{ name: "Yoga Mat Premium", qty: 1, price: 55.00 }],
    },
    {
        id: "ord_WA_5530", customer: "Carlos Rivera",    phone: "+52 55 1234 5678",    date: "28/06/2026, 16:45:00",
        address: "Av. Insurgentes Sur 1457, Col. Mixcoac, Ciudad de México, CDMX 03910, Mexico",
        items: 4, total: 310.75, status: "PENDING",    payment: "UNPAID", hoursAgo: 72,  daysAgo: 3,  tax: 0,
        orderItems: [{ name: "Gaming Headset", qty: 1, price: 129.99 }, { name: "Mouse Pad XL", qty: 1, price: 24.99 }, { name: "LED Desk Lamp", qty: 1, price: 89.99 }, { name: "Webcam HD", qty: 1, price: 65.78 }],
    },
    {
        id: "ord_WA_4489", customer: "Yuki Tanaka",      phone: "+81 90 1234 5678",    date: "27/06/2026, 11:20:00",
        address: "2-5-1 Nishi-Shinjuku, Shinjuku-ku, Tokyo 163-0001, Japan",
        items: 2, total: 199.99, status: "SHIPPED",    payment: "PAID",   hoursAgo: 96,  daysAgo: 4,  tax: 0,
        orderItems: [{ name: "Noise Cancelling Headphones", qty: 1, price: 149.99 }, { name: "Carry Pouch", qty: 1, price: 50.00 }],
    },
    {
        id: "ord_WA_3310", customer: "Fatima Al-Hassan", phone: "+966 50 123 4567",    date: "25/06/2026, 09:00:00",
        address: "Prince Mohammed Bin Abdulaziz Rd, Al Olaya, Riyadh 12211, Saudi Arabia",
        items: 1, total: 75.00,  status: "DELIVERED",  payment: "PAID",   hoursAgo: 144, daysAgo: 6,  tax: 0,
        orderItems: [{ name: "Skincare Set Premium", qty: 1, price: 75.00 }],
    },
    {
        id: "ord_WA_2201", customer: "Marco Bianchi",    phone: "+39 02 1234 5678",    date: "23/06/2026, 13:30:00",
        address: "Via Monte Napoleone 8, 20121 Milano MI, Italy",
        items: 5, total: 420.00, status: "PROCESSING", payment: "PAID",   hoursAgo: 200, daysAgo: 8,  tax: 0,
        orderItems: [{ name: "Coffee Machine Deluxe", qty: 1, price: 299.00 }, { name: "Coffee Beans 1kg", qty: 2, price: 60.50 }, { name: "Coffee Mug Set", qty: 1, price: 30.00 }],
    },
    {
        id: "ord_WA_1190", customer: "Emily Zhang",      phone: "+86 138 0013 8000",   date: "16/06/2026, 07:15:00",
        address: "No. 88 Nanjing East Road, Huangpu District, Shanghai 200001, China",
        items: 2, total: 130.50, status: "PENDING",    payment: "UNPAID", hoursAgo: 400, daysAgo: 16, tax: 0,
        orderItems: [{ name: "Digital Drawing Tablet", qty: 1, price: 99.50 }, { name: "Stylus Pen", qty: 1, price: 31.00 }],
    },
    {
        id: "ord_WA_0981", customer: "James O'Brien",    phone: "+353 87 123 4567",    date: "11/06/2026, 15:00:00",
        address: "14 Grafton Street, Dublin 2, D02 HY62, Ireland",
        items: 3, total: 278.00, status: "DELIVERED",  payment: "PAID",   hoursAgo: 500, daysAgo: 20, tax: 0,
        orderItems: [{ name: "Smart Speaker", qty: 1, price: 99.00 }, { name: "Smart Bulb Pack", qty: 2, price: 89.50 }],
    },
    {
        id: "ord_WA_0870", customer: "Sofia Müller",     phone: "+49 151 1234 5678",   date: "06/06/2026, 10:30:00",
        address: "Unter den Linden 12, 10117 Berlin, Germany",
        items: 1, total: 44.99,  status: "SHIPPED",    payment: "PAID",   hoursAgo: 600, daysAgo: 25, tax: 0,
        orderItems: [{ name: "Leather Wallet Slim", qty: 1, price: 44.99 }],
    },
];

const SIMULATE_POOL = [
    { customer: "Oliver Smith",  phone: "+44 7700 123456",   address: "10 Downing Street, Westminster, London SW1A 2AA, UK",           status: "PENDING",    payment: "UNPAID", orderItems: [{ name: "Bluetooth Speaker", qty: 1, price: 39.99 }, { name: "Phone Case", qty: 1, price: 19.99 }] },
    { customer: "Mei Lin",       phone: "+86 136 1234 5678", address: "No. 1 Xidan North Street, Xicheng District, Beijing 100032, China", status: "PROCESSING", payment: "PAID",   orderItems: [{ name: "Smart Watch Series 8", qty: 1, price: 129.00 }] },
    { customer: "Raj Patel",     phone: "+91 99887 76655",   address: "Sector 17, Chandigarh 160017, Punjab, India",                       status: "PENDING",    payment: "UNPAID", orderItems: [{ name: "Laptop Cooling Pad", qty: 1, price: 34.50 }, { name: "HDMI Cable 4K", qty: 2, price: 18.00 }] },
    { customer: "Anna Kowalski", phone: "+48 512 345 678",   address: "ul. Marszałkowska 84/92, 00-514 Warszawa, Poland",                  status: "PROCESSING", payment: "PAID",   orderItems: [{ name: "Portable Charger 20000mAh", qty: 1, price: 49.99 }] },
];

const TIME_FILTERS = [
    { key: "24h",   label: "24 Hrs"     },
    { key: "week",  label: "This Week"  },
    { key: "month", label: "This Month" },
];

const STATUS_OPTIONS = ["All Orders", "PENDING", "PROCESSING", "SHIPPED", "DELIVERED"];

const STATUS_BADGE = {
    DELIVERED:  { bg: "#1a1a2e",  color: "#fff",    border: "none" },
    PROCESSING: { bg: "#fffbea",  color: "#92600a", border: "1px solid #f0c040" },
    PENDING:    { bg: "#fff",     color: "#999",    border: "1px solid #ddd" },
    SHIPPED:    { bg: "#e8f4fd",  color: "#0968a8", border: "1px solid #bee5eb" },
};
const PAYMENT_BADGE = {
    PAID:   { bg: "#f0faf4", color: "#1a7a45", border: "1px solid #b8e0c8" },
    UNPAID: { bg: "#fff",    color: "#999",    border: "1px solid #ddd" },
};

const badge = (map, key) => {
    const s = map[key] || {};
    return { background: s.bg, color: s.color, border: s.border, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, display: "inline-block", letterSpacing: 0.5, whiteSpace: "nowrap" };
};

let simId = 1000;

const MyOrder = () => {
    const [orders, setOrders]             = useState(INITIAL_ORDERS);
    const [timeFilter, setTimeFilter]     = useState("24h");
    const [statusFilter, setStatusFilter] = useState("All Orders");
    const [search, setSearch]             = useState("");
    const [selected, setSelected]         = useState(null);

    const timeFiltered = useMemo(() => {
        if (timeFilter === "24h")   return orders.filter(o => o.hoursAgo <= 24);
        if (timeFilter === "week")  return orders.filter(o => o.daysAgo  <= 7);
        if (timeFilter === "month") return orders.filter(o => o.daysAgo  <= 30);
        return orders;
    }, [orders, timeFilter]);

    const displayed = useMemo(() => {
        let r = timeFiltered;
        if (statusFilter !== "All Orders") r = r.filter(o => o.status === statusFilter);
        if (search.trim()) {
            const q = search.toLowerCase();
            r = r.filter(o => o.id.toLowerCase().includes(q) || o.customer.toLowerCase().includes(q) || o.phone.includes(q));
        }
        return r;
    }, [timeFiltered, statusFilter, search]);

    const stats = useMemo(() => ({
        total:     timeFiltered.length,
        pending:   timeFiltered.filter(o => o.status === "PENDING").length,
        shipping:  timeFiltered.filter(o => o.status === "SHIPPED").length,
        delivered: timeFiltered.filter(o => o.status === "DELIVERED").length,
    }), [timeFiltered]);

    const handleRowClick = (order) => setSelected(p => p?.id === order.id ? null : order);

    // const handleSimulate = () => {
    //     simId++;
    //     const pick = SIMULATE_POOL[simId % SIMULATE_POOL.length];
    //     const total = pick.orderItems.reduce((s, i) => s + i.qty * i.price, 0);
    //     setOrders(prev => [{
    //         id: `ord_WA_${simId}`,
    //         customer: pick.customer,
    //         phone: pick.phone,
    //         date: "01/07/2026, 10:00:00",
    //         items: pick.orderItems.reduce((s, i) => s + i.qty, 0),
    //         total: parseFloat(total.toFixed(2)),
    //         status: pick.status,
    //         payment: pick.payment,
    //         address: pick.address,
    //         hoursAgo: 1, daysAgo: 0, tax: 0,
    //         orderItems: pick.orderItems,
    //     }, ...prev]);
    // };

    const handleProcess = () => {
        if (!selected) return;
        const updated = { ...selected, status: "PROCESSING", payment: "PAID" };
        setOrders(prev => prev.map(o => o.id === selected.id ? updated : o));
        setSelected(updated);
    };

    return (
        <DashboardLayout>
            <main className="content">
                <div className="container-fluid p-0">

                    {/* ── Top 4 Stat Cards ── */}
                    <div className="row mb-4" style={{ margin: "0 -8px" }}>
                        {[
                            { label: "TOTAL ORDERS",    value: stats.total,     icon: faShoppingCart, iconColor: "#4361ee", iconBg: "#eef0fd" },
                            { label: "PENDING ORDERS",  value: stats.pending,   icon: faClock,        iconColor: "#f39c12", iconBg: "#fef6e6" },
                            { label: "SHIPPING ORDERS", value: stats.shipping,  icon: faTruck,        iconColor: "#0984e3", iconBg: "#e8f4fd" },
                            { label: "DELIVERED ORDERS",value: stats.delivered, icon: faCheckCircle,  iconColor: "#00b894", iconBg: "#e6f9f5" },
                        ].map(card => (
                            <div className="col-6 col-md-3" key={card.label} style={{ padding: "0 8px 16px" }}>
                                <div style={{ background: "#fff", borderRadius: 14, padding: "20px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0" }}>
                                    <div>
                                        <div style={{ fontSize: 10, fontWeight: 700, color: "#aaa", letterSpacing: 1, marginBottom: 6 }}>{card.label}</div>
                                        <div style={{ fontSize: 28, fontWeight: 800, color: "#1a1a2e", lineHeight: 1 }}>{card.value}</div>
                                    </div>
                                    <div style={{ width: 48, height: 48, borderRadius: 12, background: card.iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        <FontAwesomeIcon icon={card.icon} style={{ fontSize: 20, color: card.iconColor }} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* ── Section Header ── */}
                    {/* <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 style={{ fontWeight: 800, color: "#1a1a2e", margin: 0, display: "flex", alignItems: "center", gap: 9, fontSize: 15 }}>
                            <FontAwesomeIcon icon={faShoppingCart} style={{ color: "#4361ee", fontSize: 16 }} />
                            Orders Received From WhatsApp
                        </h5>
                        <button
                            onClick={handleSimulate}
                            style={{ background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 8, padding: "9px 18px", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 7 }}
                        >
                            <FontAwesomeIcon icon={faBolt} style={{ fontSize: 12 }} />
                            Simulate WhatsApp Order
                        </button>
                    </div> */}

                    {/* ── Time Filter Tabs ── */}
                    <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
                        {TIME_FILTERS.map(f => (
                            <button
                                key={f.key}
                                onClick={() => { setTimeFilter(f.key); setSelected(null); }}
                                style={{
                                    border: "none", borderRadius: 8, padding: "6px 16px", fontSize: 12, fontWeight: 700, cursor: "pointer",
                                    background: timeFilter === f.key ? "#4361ee" : "#f0f2f8",
                                    color:      timeFilter === f.key ? "#fff"    : "#888",
                                    transition: "all 0.15s",
                                }}
                            >
                                <FontAwesomeIcon icon={faFilter} style={{ marginRight: 5, fontSize: 10 }} />
                                {f.label}
                            </button>
                        ))}
                    </div>

                    {/* ── Split Panel ── */}
                    <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>

                        {/* Left: Table */}
                        <div style={{ flex: "1 1 63%", background: "#fff", borderRadius: 14, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0", overflow: "hidden", minWidth: 0 }}>

                            {/* Search + Status Filter */}
                            <div style={{ padding: "14px 16px", borderBottom: "1px solid #f4f4f4", display: "flex", gap: 10 }}>
                                <div style={{ position: "relative", flex: 1 }}>
                                    <FontAwesomeIcon icon={faSearch} style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#bbb", fontSize: 12, pointerEvents: "none" }} />
                                    <input
                                        type="text"
                                        placeholder="Search orders, phone, client..."
                                        value={search}
                                        onChange={e => setSearch(e.target.value)}
                                        style={{ width: "100%", border: "1.5px solid #e8eaf0", borderRadius: 8, padding: "8px 12px 8px 32px", fontSize: 13, outline: "none", color: "#444", fontFamily: "inherit" }}
                                    />
                                </div>
                                <div style={{ position: "relative", flexShrink: 0 }}>
                                    <select
                                        value={statusFilter}
                                        onChange={e => setStatusFilter(e.target.value)}
                                        style={{ border: "1.5px solid #e8eaf0", borderRadius: 8, padding: "8px 34px 8px 12px", fontSize: 13, fontWeight: 600, color: "#444", background: "#fff", outline: "none", cursor: "pointer", appearance: "none", minWidth: 130, fontFamily: "inherit" }}
                                    >
                                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                    <FontAwesomeIcon icon={faChevronDown} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#bbb", fontSize: 11, pointerEvents: "none" }} />
                                </div>
                            </div>

                            {/* Table */}
                            <div style={{ overflowX: "auto" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                    <thead>
                                        <tr style={{ background: "#f8f9fc" }}>
                                            {["ORDER ID", "CUSTOMER", "ITEMS", "TOTAL", "ORDER STATUS", "PAYMENT STATUS"].map(h => (
                                                <th key={h} style={{ padding: "10px 16px", textAlign: "left", fontSize: 10, fontWeight: 700, color: "#aaa", letterSpacing: 0.8, borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
                                                    {h}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayed.length === 0 ? (
                                            <tr>
                                                <td colSpan={6} style={{ padding: "48px 16px", textAlign: "center", color: "#ccc", fontSize: 13 }}>
                                                    <FontAwesomeIcon icon={faInbox} style={{ fontSize: 28, display: "block", margin: "0 auto 10px" }} />
                                                    No orders found for this period.
                                                </td>
                                            </tr>
                                        ) : displayed.map(order => {
                                            const isSel = selected?.id === order.id;
                                            return (
                                                <tr
                                                    key={order.id}
                                                    onClick={() => handleRowClick(order)}
                                                    style={{
                                                        borderBottom: "1px solid #f4f4f4",
                                                        cursor: "pointer",
                                                        background:  isSel ? "#f4f6ff" : "transparent",
                                                        borderLeft:  isSel ? "3px solid #4361ee" : "3px solid transparent",
                                                        transition: "background 0.12s",
                                                    }}
                                                    onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = "#fafbff"; }}
                                                    onMouseLeave={e => { if (!isSel) e.currentTarget.style.background = "transparent"; }}
                                                >
                                                    <td style={{ padding: "14px 16px", fontWeight: 700, color: "#1a1a2e", whiteSpace: "nowrap" }}>{order.id}</td>
                                                    <td style={{ padding: "14px 16px" }}>
                                                        <div style={{ fontWeight: 700, color: "#1a1a2e" }}>{order.customer}</div>
                                                        <div style={{ fontSize: 11, color: "#4361ee", marginTop: 2, fontWeight: 500 }}>{order.phone}</div>
                                                    </td>
                                                    <td style={{ padding: "14px 16px", color: "#666", fontWeight: 500 }}>
                                                        {order.items} {order.items === 1 ? "Item" : "Items"}
                                                    </td>
                                                    <td style={{ padding: "14px 16px", fontWeight: 700, color: "#1a1a2e" }}>
                                                        ${order.total.toFixed(2)}
                                                    </td>
                                                    <td style={{ padding: "14px 16px" }}>
                                                        <span style={badge(STATUS_BADGE, order.status)}>{order.status}</span>
                                                    </td>
                                                    <td style={{ padding: "14px 16px" }}>
                                                        <span style={badge(PAYMENT_BADGE, order.payment)}>{order.payment}</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Right: Detail / Placeholder Panel */}
                        <div style={{ flex: "0 0 35%", background: "#fff", borderRadius: 14, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0", overflow: "hidden", minWidth: 260 }}>
                            {selected ? (
                                <div key={selected.id} style={{ animation: "slideIn 0.2s ease" }}>

                                    {/* Detail Header */}
                                    <div style={{ padding: "16px 20px", borderBottom: "1px solid #f4f4f4" }}>
                                        <div style={{ fontSize: 10, fontWeight: 700, color: "#aaa", letterSpacing: 1, marginBottom: 4 }}>DETAILED VIEW</div>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ fontWeight: 800, color: "#1a1a2e", fontSize: 16 }}>{selected.id}</div>
                                            <button
                                                onClick={() => setSelected(null)}
                                                style={{ background: "#f5f5f5", border: "none", borderRadius: 6, width: 28, height: 28, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#888" }}
                                            >
                                                <FontAwesomeIcon icon={faTimes} style={{ fontSize: 12 }} />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Customer Details */}
                                    <div style={{ padding: "16px 20px", borderBottom: "1px solid #f4f4f4" }}>
                                        <div style={{ fontSize: 10, fontWeight: 700, color: "#aaa", letterSpacing: 1, marginBottom: 12 }}>CUSTOMER DETAILS</div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                            {[
                                                { icon: faUser,          text: selected.customer,                       bold: true },
                                                { icon: faPhone,         text: selected.phone },
                                                { icon: faCalendarAlt,   text: selected.date },
                                                { icon: faMapMarkerAlt,  text: selected.address || "Address not available" },
                                            ].map(({ icon, text, bold }) => (
                                                <div key={text} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13 }}>
                                                    <div style={{ width: 28, height: 28, borderRadius: 6, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                        <FontAwesomeIcon icon={icon} style={{ fontSize: 12, color: "#4361ee" }} />
                                                    </div>
                                                    <span style={{ color: bold ? "#1a1a2e" : "#555", fontWeight: bold ? 700 : 400 }}>{text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Order Items */}
                                    <div style={{ padding: "16px 20px", borderBottom: "1px solid #f4f4f4" }}>
                                        <div style={{ fontSize: 10, fontWeight: 700, color: "#aaa", letterSpacing: 1, marginBottom: 12 }}>ORDER ITEMS</div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                            {selected.orderItems.map((item, i) => (
                                                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                                    <div>
                                                        <div style={{ fontWeight: 700, color: "#1a1a2e", fontSize: 13 }}>{item.name}</div>
                                                        <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>{item.qty}x @ ${item.price.toFixed(2)}</div>
                                                    </div>
                                                    <div style={{ fontWeight: 700, color: "#1a1a2e", fontSize: 13, flexShrink: 0, paddingLeft: 12 }}>
                                                        ${(item.qty * item.price).toFixed(2)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Order Summary */}
                                    <div style={{ padding: "16px 20px", borderBottom: "1px solid #f4f4f4" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, fontSize: 13, color: "#666" }}>
                                            <span>Subtotal</span>
                                            <span>${selected.total.toFixed(2)}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12, fontSize: 13, color: "#666" }}>
                                            <span>Tax</span>
                                            <span>${(selected.tax || 0).toFixed(2)}</span>
                                        </div>
                                        <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 12, display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 800, color: "#1a1a2e" }}>
                                            <span>Total</span>
                                            <span>${(selected.total + (selected.tax || 0)).toFixed(2)}</span>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div style={{ padding: "16px 20px", display: "flex", gap: 10 }}>
                                        <button
                                            onClick={handleProcess}
                                            style={{ flex: 1, background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 8, padding: "11px 0", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
                                        >
                                            Process Order
                                        </button>
                                        <button
                                            onClick={() => setSelected(null)}
                                            style={{ flex: 1, background: "#fff", color: "#666", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "11px 0", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                /* Placeholder */
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 28px", textAlign: "center", minHeight: 320 }}>
                                    <div style={{ width: 64, height: 64, borderRadius: 16, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
                                        <FontAwesomeIcon icon={faShoppingCart} style={{ fontSize: 26, color: "#4361ee" }} />
                                    </div>
                                    <div style={{ fontWeight: 800, color: "#1a1a2e", fontSize: 15, marginBottom: 10 }}>Select an Order</div>
                                    <div style={{ fontSize: 12, color: "#aaa", lineHeight: 1.7, maxWidth: 210 }}>
                                        Click on any incoming WhatsApp order on the left to inspect customer details, order items, and process dispatch tracking.
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </main>

            <style>{`
                @keyframes slideIn {
                    from { opacity: 0; transform: translateX(16px); }
                    to   { opacity: 1; transform: translateX(0); }
                }
            `}</style>
        </DashboardLayout>
    );
};

export default MyOrder;
